import React from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, Icon, l } from '@manychat/manyui'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { AiAutomationScenario } from 'shared/api/requests/aiAutomation/schemas'
import { typedRouting } from 'utils/router'

import cm from './styles.module.css'

export const KnowledgeAdded = () => {
  const dispatch = useAppDispatch()

  const navigate = typedRouting.useNavigate()

  const openFaqAndActivate = () => {
    navigate.aiSkills()

    dispatch(
      AiAutomationLayoutActions.currentViewReplaced({
        view: SidebarViewType.INSTANT_ANSWERS,
      }),
    )

    AiAutomationAnalytics.logAutomationEditorOpened({
      type: AiAutomationScenario.INSTANT_ANSWERS,
      source: 'first_knowlede_entry_created',
    })
  }

  const closeSidebar = () => {
    dispatch(AiAutomationLayoutActions.sidebarClosed())
  }

  return (
    <div className={cm.wrapper}>
      <SidebarHeader />

      <section className={cm.successScreen}>
        <div className={cm.successScreen__content}>
          <Icon.DoubleTick className={cm.successScreen__icon} size={32} />

          <h2 className="m-t-sm text-subheading">
            {l.translate("You're ready to Always-On Answers")}
          </h2>

          <p className="m-t-xxs">
            {l.translate(
              'AI now understands your business and can handle incoming customer questions.',
            )}
          </p>

          <div className={cm.successScreen__buttons}>
            <BtnV2
              onClick={openFaqAndActivate}
              variant="primary"
              data-test-id="ai-flow/replace-router-with-instant-answers-button"
              fullWidth
            >
              {l.translate('Enable answers')}
            </BtnV2>

            <BtnV2
              as={Link}
              to={typedRouting.linkBuilder.aiTraining()}
              onClick={closeSidebar}
              variant="ghost-light"
              className="m-t-xs"
              data-test-id="ai-automation/replace-router-with-knowledge-button"
              fullWidth
            >
              {l.translate('Review Training')}
            </BtnV2>
          </div>
        </div>
      </section>
    </div>
  )
}
